import '../components/test.css'
import Assesment from '../components/admin/ViewAssesment/assesment'


function ViewAssesment() {
 

  return (
    <div className='newAdmin'>  
      <Assesment/>
    </div>
  )
}

export default ViewAssesment
